import {SegmentProps} from 'platform/components';

import i18n from '@dms/i18n';

import {OwnerSegment} from '../hooks/useRedirectFromOpportunities/types/OwnerSegment';
import {TypeSegment} from '../hooks/useRedirectFromOpportunities/types/TypeSegment';

const owner: NonNullable<SegmentProps<OwnerSegment>['options']> = [
  {
    label: i18n.t('page.homepage.labels.total'),
    value: 'total',
  },
  {
    label: i18n.t('page.homepage.labels.my'),
    value: 'my',
  },
];

const type: NonNullable<SegmentProps<TypeSegment>['options']> = [
  {
    label: i18n.t('page.homepage.labels.selling'),
    value: 'selling',
  },
  {
    label: i18n.t('page.homepage.labels.buying'),
    value: 'buying',
  },
];

export const OPPORTUNITIES_FUNNEL_SEGMENTS = {owner, type};
